import gql from "graphql-tag";
import { SaveTemplateCharacteristicsOrder_saveTemplateCharacteristicsOrder } from "@/models/mutations/types/SaveTemplateCharacteristicsOrder";

export const SAVE_TEMPLATE_CHARACTERISTICS_ORDER = gql`
  mutation SaveTemplateCharacteristicsOrder($templateId: ID!, $order: [TemplateCharacteristicsOrderInput!]!) {
    saveTemplateCharacteristicsOrder(templateId: $templateId, order: $order) {
      id
    }
  }
`;

export type SaveTemplateCharacteristicsOrderResult = SaveTemplateCharacteristicsOrder_saveTemplateCharacteristicsOrder;
